import { useState, useEffect } from "react";
import { getBarToday } from "../api";
import TimePicker from "./TimePicker";
import { saveMeldung } from "../api";

function getToday() { return new Date().toLocaleDateString("de-DE"); }
function getTime() { return new Date().toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" }); }

export default function EndShiftScreen({ employee, barTotal, totalSales, totalRevenue, onConfirm, onBack }) {
  const [step, setStep] = useState("time");
  const [hour, setHour] = useState(20);
  const [minute, setMinute] = useState(0);
  const [showNote, setShowNote] = useState(false);
  const [note, setNote] = useState("");
  const [sent, setSent] = useState(false);

  const endTime = String(hour).padStart(2,"0") + ":" + String(minute).padStart(2,"0");

  const [sheetBarTotal, setSheetBarTotal] = useState(null);

  useEffect(() => {
    if (step === "confirm") {
      getBarToday().then(data => {
        setSheetBarTotal(data.barTotal || 0);
      }).catch(() => {});
    }
  }, [step]);

  const displayBarTotal = sheetBarTotal !== null ? sheetBarTotal : barTotal;

  if (step === "time") return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", minHeight:"100vh", padding:"40px 24px", gap:40 }} className="fade-in">
      <div style={{ textAlign:"center" }}>
        <div style={{ color:employee?.color, fontSize:26, fontWeight:700 }}>{employee?.name}</div>
        <div style={{ color:"#444", fontSize:12, marginTop:6, letterSpacing:3 }}>WANN HOERST DU AUF?</div>
      </div>
      <TimePicker hour={hour} minute={minute} onHourChange={setHour} onMinuteChange={setMinute} />
      <div style={{ color:"#333", fontSize:11, letterSpacing:2 }}>10:00 - 20:00</div>
      <button onClick={() => setStep("confirm")}
        style={{ width:"100%", padding:"20px", borderRadius:18, border:"none", background:"linear-gradient(135deg,#00E5FF,#00B8CC)", color:"#000", fontSize:18, fontWeight:700, cursor:"pointer", boxShadow:"0 4px 20px #00E5FF30" }}>
        Weiter
      </button>
      <button onClick={onBack} style={{ padding:14, color:"#333", background:"transparent", border:"none", cursor:"pointer" }}>Zuruck</button>
    </div>
  );

  return (
    <div style={{ display:"flex", flexDirection:"column", minHeight:"100vh", padding:"48px 24px 36px", alignItems:"center", justifyContent:"center", gap:24 }} className="fade-in">
      <div style={{ textAlign:"center" }}>
        <div style={{ fontSize:44, marginBottom:10 }}>locked</div>
        <div style={{ fontSize:26, fontWeight:700 }}>Schicht beenden</div>
        <div style={{ color:"#444", fontSize:14, marginTop:4 }}>{employee?.name} bis {endTime}</div>
      </div>
      <div style={{ background:"#131313", border:"1.5px solid #1E1E1E", borderRadius:24, padding:"32px 24px", width:"100%", textAlign:"center" }}>
        <div style={{ color:"#444", fontSize:11, letterSpacing:3, marginBottom:10 }}>BAR-KASSE HEUTE</div>
        <div style={{ fontFamily:"Space Mono monospace", fontSize:48, fontWeight:700, color:"#22C55E" }}>EUR {displayBarTotal.toFixed(2)}</div>
        <div style={{ color:"#333", marginTop:14, fontSize:14 }}>{totalSales} Verkaufe Gesamt EUR {totalRevenue.toFixed(2)}</div>
      </div>
      <div style={{ width:"100%", color:"#666", textAlign:"center", fontSize:16, lineHeight:1.6 }}>Ist dieser Betrag in der Kasse vorhanden?</div>
      {showNote && sent === false && <div style={{ width:"100%" }}><textarea rows={3} placeholder="Problem beschreiben..." value={note} onChange={e=>setNote(e.target.value)} /></div>}
      {sent && <div style={{ color:"#22C55E", textAlign:"center", padding:"12px", fontSize:14, background:"#22C55E15", borderRadius:12 }}>Meldung gesendet</div>}
      <div style={{ display:"flex", flexDirection:"column", gap:10, width:"100%" }}>
        <button onClick={() => onConfirm(endTime)} style={{ padding:19, borderRadius:18, border:"none", background:"linear-gradient(135deg,#22C55E,#16A34A)", color:"#000", fontSize:17, fontWeight:700, cursor:"pointer", boxShadow:"0 4px 20px #22C55E30" }}>
          Bestaetigen und Beenden
        </button>
        {sent === false && (
          <button onClick={async () => {
            if (showNote === false) { setShowNote(true); return; }
            setSent(true);
            await saveMeldung({
              date: getToday(),
              time: getTime(),
              employeeName: employee?.name,
              note: note,
              barTotal: barTotal
            });
            setTimeout(() => onConfirm(endTime), 1500);
          }} style={{ padding:17, borderRadius:16, border:"1px solid #EF444430", background:"#EF444410", color:"#EF4444", fontSize:15, fontWeight:600, cursor:"pointer" }}>
            {showNote ? "Meldung absenden" : "Problem melden"}
          </button>
        )}
        <button onClick={onBack} style={{ padding:14, color:"#303030", background:"transparent", border:"none", cursor:"pointer" }}>Zuruck</button>
      </div>
    </div>
  );
}
